import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store/'
import VeeValidate from "./plugins/vee-validate";
import VueCookie from "vue-cookie";
import VueQr from 'vue-qr';
import "vuetify/dist/vuetify.min.css";
import '@mdi/font/css/materialdesignicons.css'
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css'
import 'mavon-editor/dist/markdown/github-markdown.min.css'
import 'mavon-editor/dist/highlightjs/highlight.min.js'
import 'mavon-editor/dist/katex/katex.min.css'
import 'mavon-editor/dist/katex/katex.min.js'
import 'mavon-editor/dist/css/index.css';
import VueMarkdown from 'vue-markdown';
import SocialSharing from 'vue-social-sharing';
import VueApexCharts from 'vue-apexcharts';
import VueSwal from 'vue-swal';
import VueGtag from 'vue-gtag';

Vue.use(mavonEditor)
Vue.mixin(VeeValidate)
Vue.use(VueCookie);
Vue.use(SocialSharing)
Vue.use(VueApexCharts)
Vue.use(VueSwal)
Vue.config.productionTip = false
Vue.prototype.$axios = axios;

axios.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json'
        if (store.state.auth.accessToken) {
        // リクエストヘッダーにAuthorizationを追加
        config.headers['Authorization'] = `Bearer ${store.getters['auth/isAuth']}`
        }
        return config;
    },
)

axios.interceptors.response.use(
    function(response) {
      // Do something with response data
        return response
    },
    async function(error) {
        console.log('error status: ' + error.response?.status);
        store.commit('error/setErrors', error.response);
        let message = "";
        switch(error.response?.status) {
            case 400:
                throw error;
            case 401:
                store.dispatch('auth/deleteAuth')
                // ログイン画面以外の場合はログイン後にリダイレクトするためのURLを保存
                if (location.pathname !== '/login') {
                    // store.dispatchが非同期処理なので本番とローカルで取得できるページが異なるため、pathの取得を待つように修正
                    await store.dispatch('auth/createForNotLoginRedirectUrl', location.pathname + location.search);
                }
                router.push({ name: 'login'})
                location.reload();
                break;
            case 404:
                router.push({ name: 'error' });
                break;
            case 409:
                throw error;
            case 422:
                Object.keys(error.response.data.errors).forEach(function (key) {
                    message = error.response.data.errors[key][0];
                });
                // Vue.use(VueSwal).$swal({
                //     title: "入力エラー",
                //     text: message,
                //     icon: 'error',
                // });
                // setTimeout(function() {
                //     location.reload();
                //   }, 3000);
                alert(message);
                location.reload();
                break;
            case 428:
                throw error;
            default:
                router.push({ name: 'error' });
                break;
        }
    }
)

Vue.use(VueGtag, {
    config: {
    //   id: 'G-0F1J3F9P8B'
      id: 'G-CVNK009SWX'
    }
})

new Vue({
    VueMarkdown,
    router,
    vuetify,
    render: h => h(App),
    store,
    VueCookie,
    VueQr,
    VueSwal,
}).$mount('#app')